import styled from 'styled-components';

export const InputRadioSyle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  label {
    margin: 0;
    font-size: 14px;
    line-height: 14px;
    color: #7a7a7a;
    cursor: pointer;
  }

  input {
    appearance: none;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    border: 2px solid ${({ theme }) => theme.colors.lightGray};
    transition: 0.2s all linear;
    position: relative;
    cursor: pointer;

    &:focus {
      box-shadow: none;
      outline: none;
    }
  }

  input:checked {
    border: 2px solid ${({ theme }) => theme.colors.blue};
  }

  &:checked {
    opacity: 1 !important;
  }

  input[type='radio'] {
    border-radius: 50%;

    &:after {
      display: block;
      content: '';
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: ${({ theme }) => theme.colors.lightBlue};
      opacity: 0;
      transform: scale(0.7, 0.7);
    }

    &:not(.switch) {
      &:after {
        opacity: var(--o, 0);
      }
      &:checked {
        --o: 1;
      }
    }
  }
`;
